// extracted by mini-css-extract-plugin
export default {"progress":"styles_progress__tuut0","progress_bar":"styles_progress_bar__-D6vl"};